import dayjs from "dayjs";
import { Dayjs } from "dayjs";
import duration from "dayjs/plugin/duration";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(duration);
dayjs.extend(localizedFormat);

const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

const DATE_FORMAT = 'll';
const TIME_FORMAT = 'HH:mm';

const formatDateRange = function(start: dayjs.ConfigType, end: dayjs.ConfigType, withTime = true) {
    let text = '';
    let startDateTime = dayjs(start);
    let endDateTime = dayjs(end);

    if (startDateTime.add(1, 'day').isSame(endDateTime)) {
        text += startDateTime.format(DATE_FORMAT)
    } else if (endDateTime.isSame(startDateTime, 'day')) {
        text += startDateTime.format(DATE_FORMAT)
        if (withTime) {
            text += ' ' + startDateTime.format(TIME_FORMAT)
            text += ' → '
            text += endDateTime.format(TIME_FORMAT)
        }
    } else {
        text += startDateTime.format(DATE_FORMAT) + ' ' + (withTime ? startDateTime.format(TIME_FORMAT) : '')
        text += ' -> '
        text += endDateTime.format(DATE_FORMAT) + ' ' + (withTime ? endDateTime.format(TIME_FORMAT) : '')
    }
    return text;
}

const displayDate = function(date, withTime = false) {
    return dayjs(date).format(withTime ? 'lll' : 'll');
}

const isPeriodOverlappingDate = function(startOfPeriod: Dayjs, endOfPeriod: Dayjs, date:Dayjs) {
    let startOfDate = date.startOf('day');
    let endOfDate = date.endOf('day');

    return startOfPeriod.isBefore(endOfDate) && (!endOfPeriod || endOfPeriod.isAfter(startOfDate));
}

export type PeriodState = 'upcoming' | 'ongoing' | 'ended' | 'permanent';

const periodState = function(start?: string | null, end?: string | null, now: Dayjs = dayjs()): PeriodState {
    const startDate = start ? dayjs(start) : null;
    const endDate = end ? dayjs(end) : null;

    if (!startDate && !endDate) {
        return 'permanent';
    }
    if (startDate && now.isBefore(startDate)) {
        return 'upcoming';
    }
    if (endDate && now.isAfter(endDate)) {
        return 'ended';
    }
    return 'ongoing';
}


const periodFromString = function(periodString: string): [Dayjs, Dayjs] | null {
    const now = dayjs();

    switch (periodString) {
        case 'today':
            return [now.startOf('day'), now.endOf('day')];

        case 'yesterday':
            const yesterday = now.subtract(1, 'day');
            return [yesterday.startOf('day'), yesterday.endOf('day')];

        case 'tomorrow':
            const tomorrow = now.add(1, 'day');
            return [tomorrow.startOf('day'), tomorrow.endOf('day')];

        case 'after_tomorrow':
            const afterTomorrow = now.add(2, 'day');
            return [afterTomorrow.startOf('day'), afterTomorrow.endOf('day')];

        case 'this_week':
            return [now.startOf('week'), now.endOf('week')];

        case 'last_week':
            const lastWeek = now.subtract(1, 'week');
            return [lastWeek.startOf('week'), lastWeek.endOf('week')];

        case 'next_week':
            const nextWeek = now.add(1, 'week');
            return [nextWeek.startOf('week'), nextWeek.endOf('week')];

        case 'this_month':
            return [now.startOf('month'), now.endOf('month')];

        case 'last_month':
            const lastMonth = now.subtract(1, 'month');
            return [lastMonth.startOf('month'), lastMonth.endOf('month')];

        case 'this_year':
            return [now.startOf('year'), now.endOf('year')];

        case 'last_six_months':
            return [now.subtract(5, 'month').startOf('month'), now.endOf('month')];

        default:
            return null;
    }
}
const secondsToDuration = function(totalSeconds: number): string {
    return dayjs.duration(parseInt(totalSeconds), 'seconds').humanize()
}

export {
    DAYS,
    formatDateRange,
    displayDate,
    isPeriodOverlappingDate,
    periodState,
    periodFromString,
    secondsToDuration
}
